import { NoMatchError, } from './Exceptions';
export function local_ref(ref_like_string) {
    if (/\s+/.test(ref_like_string)) {
        throw new Error('No spacing characters allowed!');
    }
    if (ref_like_string.startsWith('#/$defs/')) {
        throw new NoMatchError(ref_like_string, 'Already a local ref!');
    }
    return `#/$defs/${ref_like_string}`;
}
export function is_string(maybe) {
    return 'string' === typeof maybe;
}
export function is_$ref(maybe) {
    return is_string(maybe) && maybe.startsWith('#/$defs/');
}
export function $ref_in_array(maybe_$ref, $ref_array) {
    return is_$ref(maybe_$ref) && $ref_array.includes(maybe_$ref);
}
//# sourceMappingURL=StringStartsWith.js.map